// extracted by mini-css-extract-plugin
module.exports = {"label":"Textarea-styles_label__21oU_","textarea":"Textarea-styles_textarea__2_SaF","container":"Textarea-styles_container__377UZ"};